const constants = {
    BASE_URL: "https://www.server.tadashii.codexflow.co",
    // BASE_URL: "http://localhost:5000",
  };
  
  export default constants;
  
  